// extracted by mini-css-extract-plugin
export default {"fr-view":"LegendPin_fr-view__pXuYU","legend-pin":"LegendPin_legend-pin__QvZBN","isActive":"LegendPin_isActive__BAnNF"};